<!-- eslint-disable prettier/prettier -->
<template>
  <div :class="cardClass">

    <assignment-rights 
      v-show="userID"
      :targetRights="localItem.targetRights"
      :idElement="localItem.id"
      :userID="userID"
      @changeHoverCard="changeHoverCard" 
      @saveManageAssigment="saveManageAssigment" 
    />
    
    <v-card class="mx-auto card" outlined>
      <v-list-item class="mb-0 custom-content-list">
        <v-list-item-content>
          <div class="flex flex-task-content">
            <div 
              :class="{
                'dop-pd': showScore(localItem) && isTask,
                'dop-full': !isTask
              }"
            >
              <!-- Заголовок -->
              <v-list-item-title
                class="text-h6 mb-1 custom-layout-title"
                :style="titleStyle"
              >
              {{ localItem.title }}
                
              </v-list-item-title>

              <!-- Описание -->
              <v-list-item v-if="!isTask || (isTask && localItem.description)" class="markCard-description" :class="descriptionClass">
                {{ localItem.description }}
              </v-list-item>

              <!-- Файлы задания -->
              <div v-if="isTask && taskFiles.length" class="border-div borderNone w-100 mb-3">
                <label>Файлы для задания:</label>
                <section class="container-tab rel">
                  <files-component
                    :isAdmin="isAdmin"
                    :arrFiles="taskFiles"
                    @removeFile="removeFile"
                  />
                </section>
              </div>

            </div>
            <div v-if="isTask">

              <div class="w-100" >
                <div class="mark-card__answer block text-h8 mb-1 pl-0 mb-4">
                  <p class="text-h6 mt-0 custom-layout-title mark-card__answer-title">Ответ на задание</p>
                  <span v-if="!hasAnswer && answerMode === 'view'">Пусто</span>
                </div>

                <!-- Просмотр ответа -->
                <div v-if="hasAnswer && answerMode === 'view'" class="mark-card__answer block text-h8 mb-1 mt-1 pl-0 mb-4">
                  
                  <div v-if="localItem.gitUrl">
                    <label>Ссылка на git</label>
                    <v-list-item class="mb-2 mt-0 pl-0">
                      <a :href="localItem.gitUrl" target="_blank" class="break-word">{{ localItem.gitUrl }}</a>
                    </v-list-item>
                  </div>

                  <div v-if="localItem.answerText">
                    <label>Пояснение</label>
                    <v-list-item class="mb-2 mt-0 pl-0">{{ localItem.answerText }}</v-list-item>
                  </div>

                  <div v-if="answerFiles.length" class="border-div borderNone w-100 mb-3">
                    <label>Файлы ответа</label>
                    <section class="container-tab rel">
                      <table>
                        <tr>
                          <td v-for="file in answerFiles" :key="file.id" class="custom-i">
                            <a :href="rootUrl + getFileHref(file)" target="_blank" :title="getFileName(file)">
                              <i :class="fileIcon(getFileExt(file))" />
                              <span>{{ getFileName(file) }}</span>
                            </a>
                          </td>
                        </tr>
                      </table>
                    </section>
                  </div>
                </div>

                <!-- Создание/Редактирование ответа -->
                <v-form ref="answerForm" lazy-validation v-if="answerMode === 'create' || answerMode === 'edit'" class="mark-card__answer block text-h8 mb-1 mt-1 pl-0 mb-4">
                  
                  <label>Ссылка на git</label>
                  <v-text-field v-model="link" type="url" :rules="urlRules" dense />

                  <label>Пояснение</label>
                  <v-textarea v-model="answer" dense />

                  <div style="padding: 0;">
                    <label class="pd-lr-10" style="width: 100%; padding: 0 !important;">Файлы ответа</label>

                    <user-card class="user-card pd-lr-10" style="padding: 0 !important;">
                      <template v-slot:body>
                        <p class="file-error">{{ answerFileError }}</p>

                        <div class="container-tab rel" @dragover.prevent @drop.prevent>
                          <div
                            @dragover.prevent="onAnswerDragOver"
                            @dragleave.prevent="onAnswerDragLeave"
                            @drop.prevent="onAnswerDrop"
                            :class="{ 'is-dragover': answerDragOver }"
                          >
                            <span
                              v-if="answerFiles.length === 0 && answerFilesNew.length === 0"
                              class="drag-text"
                              style="padding: 0; margin-left: 92px; text-align: left; width: 65%; max-height: 25px"
                            >
                              Перетащите файлы для загрузки
                            </span>

                            <table>
                              <tr>
                                <td class="plus-block">
                                  <label for="answerFile" style="margin: 0;">
                                    <v-icon>ti-plus</v-icon>
                                    <input
                                      id="answerFile"
                                      type="file"
                                      multiple
                                      accept=".txt,.pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                                      @change="onAnswerPick"
                                      style="display:none;"
                                    />
                                  </label>
                                </td>

                                <td v-for="file in answerFilesNew" :key="file.name" class="newFile custom-i">
                                  <v-btn class="close-button custom-close btn-pd" variant="text" @click="removeAnswerNewFile(file)">
                                    <v-icon>ti-close</v-icon>
                                  </v-btn>
                                  <a :href="file.url" target="_blank" :title="file.name">
                                    <i :class="fileIcon(file.fileExtension)"></i>
                                    <span class="text-10" style="padding: 0 5px;">{{ file.name }}</span>
                                  </a>
                                </td>

                                <!-- показать существующие файлы ответа при edit -->
                                <td 
                                  v-if="answerMode === 'edit'" 
                                  v-for="(file, i) in answerFiles"
                                  :key="'old-' + (file.file_link || file.file_name || i)"
                                  class="custom-i"
                                >
                                  <v-btn
                                    class="close-button custom-close btn-pd center-icon"
                                    variant="text"
                                    @click="delFile(file.id, 'candidate')"
                                    title="Удалить файл"
                                  >
                                    <v-icon>ti-close</v-icon>
                                  </v-btn>

                                  <a :href="rootUrl + file.file_link" target="_blank">
                                    <i :class="fileIcon(file.file_type)"></i>
                                    <span class="text-10" style="padding: 0 5px;">{{ getFileName(file) }}</span>
                                  </a>

                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </template>
                    </user-card>

                  </div>

                  <div class="text-center">
                    <v-btn class="btnSave primary-btn mr-3" @click.native.prevent="submitAnswer">
                      Сохранить ответ
                    </v-btn>

                    <v-btn class="btnSave" text @click.native.prevent="cancelAnswerEdit">
                      Отмена
                    </v-btn>
                  </div>
                </v-form>
              </div>

              <!-- Если рук или админ, то может добавить ответ только для себя, для остальных только смотреть -->
              <div v-if="((!userID && !isAdmin) || (userID == curUser && isAdmin)) && localItem.viewerRights && localItem.viewerRights.canPostAnswer" class="mb-5">
                <v-btn
                  v-if="!hasAnswer && answerMode === 'view'"
                  class="btnSave primary-btn"
                  @click.native.prevent="startCreateAnswer"
                >
                  Добавить ответ
                </v-btn>

                <v-btn
                  v-if="hasAnswer && answerMode === 'view'"
                  class="btnSave primary-btn"
                  @click.native.prevent="startEditAnswer"
                >
                  Изменить ответ
                </v-btn>
              </div>

            </div>
          </div>

        </v-list-item-content>

        <!-- Оценка -->
        <v-avatar v-show="showScore(localItem)" class="score-circle" size="52">
          <span class="white--text text-h4-custom">{{ scoreNumber }}</span>
        </v-avatar>
      </v-list-item>

      <!-- Открыть -->
      <v-card-actions v-if="showOpenButton">
        <v-btn
          @click.native="goToCompetency(localItem)"
          text
          x-small
          class="go-btn primary-icon-btn"
        >
          Открыть
          <v-icon small>mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>

      <!-- Footer оценок -->
      <v-footer v-show="showMarksFooter(item)" :class="footerClass">
        <marks-list-second-variant
          @selectMark="selectMark"
          :score="score"
          :type="skillTypeForColor"
        />
      </v-footer>
    </v-card>
  </div>
</template>

<script>
import UserCard from "@/pages/UserProfileTeamplate/UserCard";
import MarksList from "@/components/MarksList";
import MarksListSecondVariant from "@/components/MarksListSecondVariant";
import AssignmentRights from "@/components/AssignmentRights";
import filesComponent from "@/components/filesComponent";
import globalMethods from "@/plugins/globalMethods";

import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";

import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: "CompetencyMarkCard",
  props: [
    "userID",
    "item",
    "score",
    "canChangeEntities",
    "type",
    "typeSkill",
    "isAdmin"
  ],

  components: {
    UserCard,
    MarksList,
    MarksListSecondVariant,
    AssignmentRights,
    filesComponent,
  },

  data() {
    return {
      roles: [],
      link: "",
      answer: "",
      skillTypeForColor: "HS",
      filelist: [],
      flagEdit: false,
      hover: false,
      fileError: "",

      answerMode: "view", // view | create | edit
      answerFilesNew: [], // новые файлы ответа (File[])
      answerDragOver: false,
      answerFileError: "",

      rootUrl: process.env.VUE_APP_FILE_URL,
      urlRules: [
        v => {
          const s = String(v || "").trim();
          if (!s) return true;
          try {
            const u = new URL(s);
            return (u.protocol === "http:" || u.protocol === "https:") || "Только http/https";
          } catch (e) {
            return "Введите корректную ссылку";
          }
        }
      ],

      curUser: parseInt(localStorage.getItem("current_user")),
      };
  },

  computed: {
    localItem() {
      return this.item;
    },

    isTask() {
      return this.type === "tasks";
    },

    titleStyle() {
      return (this.localItem.type === "task" || this.localItem.type === "question")
        ? "font-size:14px; line-height:1.3; font-weight:500; padding-bottom:10px;"
        : "";
    },

    descriptionStyle() {
      return !this.localItem.description ? "display:none;" : "";
    },

    descriptionClass() {
      if (this.isTask) return "mb-4 mt-4 pl-0";
      if (this.isTask) return "text-h8 mb-1 mt-1 pl-0";
      return "sub-text text-h8 mb-1 mt-1 pl-0";
    },

    /** Показывать ли блок файлов */
    showTaskFiles() {
      return this.isTask && this.localItem.files && this.localItem.files.length > 0;
    },

    scoreNumber() {
      return globalMethods.getNumber(this.score || 0);
    },

    scoreColor() {
      return this.skillTypeForColor === "HS" ? "#41b883" : "#1976d2";
    },

    showOpenButton() {
      return this.localItem.type !== "task" && this.localItem.type !== "question";
    },

    footerClass() {
      return this.isTask ? "mb-0 mark-list" : "mb-0";
    },

    cardClass() {
      const base = this.isTask ? "markCard markCardTask" : "markCard";
      return this.hover ? base + " is-hovered" : base;
    },

    isHR() {
      return globalMethods.isHR(this.roles);
    },

    taskFiles() {
      var files = (this.localItem && this.localItem.files) ? this.localItem.files : [];
      return files.filter(this.isConditionFile);
    },
    answerFiles() {
      var files = (this.localItem && this.localItem.files) ? this.localItem.files : [];
      return files.filter(function(f) {
        return !(f && f.file_attachment_type === "condition");
      });
    },

    hasAnswerFiles() {
      return this.answerFiles && this.answerFiles.length > 0;
    },

    hasAnswer() {
      return !!(
        this.localItem &&
        (
          (this.localItem.gitUrl && String(this.localItem.gitUrl).trim()) ||
          (this.localItem.answerText && String(this.localItem.answerText).trim()) ||
          this.hasAnswerFiles
        )
      );
    },

  },

  mounted() {
    this.roles = globalMethods.getRoles();

    this.skillTypeForColor =
      this.localItem.type === "area" ? this.typeSkill : this.$store.state.globalSkill;

    this.link = this.localItem.gitUrl || "";
    this.answer = this.localItem.answerText || "";
    this.answerMode = "view";

  },

  methods: {
    goToCompetency(item) {
      this.$emit("goTo", item);
    },

    selectMark(mark) {
      this.localItem.mark = mark;
      this.$emit("selectMark", this.localItem);
    },

    fileIcon(ext) {
      const map = {
        doc: "fa fa-file-word-o",
        docx: "fa fa-file-word-o",
        xls: "fa fa-file-excel-o",
        xlsx: "fa fa-file-excel-o",
        jpg: "fa fa-file-image-o",
        jpeg: "fa fa-file-image-o",
        png: "fa fa-file-image-o",
        pdf: "fa fa-file-pdf-o",
      };
      return map[ext] || "fa fa-file-o";
    },

    dragFile(e) {
      const files = [...e.dataTransfer.files];
      let base = ((this.localItem.userFiles && this.localItem.userFiles.length > 0) || 0) + this.filelist.length;

      files.forEach((f, i) => {
        this.filelist.push({
          id: base + i + 1,
          title: f.name,
        });
      });
    },

    uploadFile() {
      alert("Загрузка файла пока не реализована");
    },

    editAnswer() {
      this.flagEdit = true;
      this.filelist = [];
    },

    saveAnswer(item) {
      item.answer = this.answer;
      item.git_link = this.link;

      item.userFiles = [
        ...(item.userFiles || []),
        ...this.filelist,
      ];

      this.flagEdit = false;
      this.filelist = [];

      this.notifyVue('bottom', 'right', 'warning', "Сохранение ответа будет позже");
    },

    deleteNewFile(file) {
      this.filelist = this.filelist.filter(f => f.id !== file.id);
    },

    changeHoverCard(val) {
      this.hover = val;
    },

    addFiles(e) {
      const files = Array.from(e.target.files);
      this.appendFiles(files);
    },

    appendFiles(files) {
      this.fileError = "";
      const allowed = ["txt", "pdf", "doc", "docx", "xls", "xlsx", "png", "jpg", "jpeg"];

      files.forEach(file => {
        const ext = file.name.split(".").pop().toLowerCase();

        if (allowed.indexOf(ext) === -1) {
          this.fileError = "Запрещённый формат файла";
          return;
        }

        if (!this.filelist.find(f => f.name === file.name)) {
          this.filelist.push(file);
        }
      });
    },

    showScore(item) {
      if (!this.userID && this.isAdmin) return false;

      return !!(item && item.viewerRights && item.viewerRights.canViewScore)
    },

    showMarksFooter(item) {
      if (!this.userID && this.isAdmin)  return false;

      // Начинаем оценку с Компетенций
      if (["area"].includes(item.type)) return false;

      return !!(item && item.viewerRights && item.viewerRights.canPostScore)

      // HR может ставить только SS
      // if (this.isHR) {
      //   return this.skillTypeForColor === "SS";
      // }

      // return true;
    },

    // Пользователь видит форму создания ответа
    showAnswerForm(item) {
      if (item.type !== "task") return false;
      if (this.flagEdit) return false;

      return !!(item && item.viewerRights && item.viewerRights.canPostAnswer)

      // return !(this.localItem.answer && this.localItem.git_link);
    },

    /** Просмотр ответа */
    showAnswerView(item) {
      return (
        item.type === "task" &&
        !this.flagEdit &&
        item.answer &&
        item.git_link
      );
    },

    /** Редактирование ответа */
    showAnswerEdit(item) {
      return (
        item.type === "task" &&
        this.flagEdit &&
        item.answer &&
        item.git_link
      );
    },

    notifyVue(verticalAlign, horizontalAlign, color, text) {
      this.$notify({
        component: NotificationTemplate,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color,
        message: text,
      });
    },

    saveManageAssigment(res) {
      this.$emit("saveManageAssigment", res);
    },

    isConditionFile(file) {
      return file && file.file_attachment_type === "condition";
    },

    getFileHref(file) {
      return (file && (file.filePath || file.file_link || file.file_path)) ? (file.filePath || file.file_link || file.file_path) : "#";
    },

    getFileName(file) {
      return (file && (file.realFileName || file.file_name || file.title || file.name)) ? (file.realFileName || file.file_name || file.title || file.name) : "file";
    },

    getFileExt(file) {
      var name = this.getFileName(file);
      var parts = name.split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "";
    },

    onAnswerDragOver() { 
      this.answerDragOver = true; 
    },
    onAnswerDragLeave() { 
      this.answerDragOver = false; 
    },

    onAnswerDrop(e) {
      this.answerDragOver = false;
      var files = Array.from(e.dataTransfer.files);
      this.appendAnswerFiles(files);
    },

    onAnswerPick(e) {
      var files = Array.from(e.target.files);
      this.appendAnswerFiles(files);
      e.target.value = "";
    },

    appendAnswerFiles(files) {
      this.answerFileError = "";
      var allowed = ["txt", "pdf", "doc", "docx", "xls", "xlsx", "png", "jpg", "jpeg"];

      for (var i = 0; i < files.length; i++) {
        var f = files[i];
        var ext = f.name.split(".").pop().toLowerCase();

        if (allowed.indexOf(ext) === -1) {
          this.answerFileError = "Запрещённый формат файла";
          continue;
        }
        // защита от дублей по имени
        var exists = false;
        for (var j = 0; j < this.answerFilesNew.length; j++) {
          if (this.answerFilesNew[j].name === f.name) { exists = true; break; }
        }
        if (!exists) this.answerFilesNew.push(f);
      }
    },

    removeAnswerNewFile(file) {
      this.answerFilesNew = this.answerFilesNew.filter(function(f) { return f.name !== file.name; });
    },

    cancelAnswerEdit() {
      this.answerFilesNew = [];
      this.answerFileError = "";
      this.answerDragOver = false;

      // возвращаем значения из item (на случай edit)
      this.link = this.localItem.gitUrl || "";
      this.answer = this.localItem.answerText || "";

      this.answerMode = "view";
    },

    async submitAnswer() {
      var id = this.localItem && this.localItem.id ? this.localItem.id : 0;
      if (!id) return;

      if (this.$refs.answerForm && !this.$refs.answerForm.validate()) {
        return;
      }

      const hasTaskFiles = this.answerFilesNew && this.answerFilesNew.length;

      try {
        const fd = new FormData();

        fd.append("gitUrl", this.link);
        fd.append("answerText", this.answer);

        if (hasTaskFiles) {
          // добавить файлы в taskCandidateFiles
          for (var i = 0; i < this.answerFilesNew.length; i++) {
            var f = this.answerFilesNew[i];
            if (f) {
              fd.append("candidateFiles[]", f);
            }
          }
        }

        const res = await GlobalRequest.request(
          "/task/" + id + "/response",
          "POST",
          fd,
          "multipart/form-data"
        );

        if(res && res.success && res.data) {
          // if (hasTaskFiles) {
          //   // Пока если грузим файлы, то обновляем целиком
          //   this.$emit("reloadObj", id);
          // } else {
            // this.applyAnswerLocal({ gitUrl: this.link, answerText: this.answer });
            // this.applyAnswerLocal(res.data);
          // }
          this.applyAnswerLocal(res.data);
        } else {
          this.notifyVue("bottom", "right", "danger", "Не удалось сохранить ответ");
        }
      } catch (e) {
        console.error("Ошибка сохранения ответа:", e);
        this.notifyVue("bottom", "right", "danger", "Не удалось сохранить ответ");
        return;
      }

      this.answerFilesNew = [];
      this.answerMode = "view";

      // обновить данные задания
      // this.$emit("reloadObj", id);

    },

    applyAnswerLocal(apiData) {
      if (!this.localItem) return;

      this.localItem.gitUrl = apiData.git_url || "";
      this.localItem.answerText = apiData.answer_text || "";

      this.localItem.files = (this.localItem.files || []).concat(apiData.candidateFiles || []);
    },

    startCreateAnswer() {
      this.link = "";
      this.answer = "";
      this.answerFilesNew = [];
      this.answerFileError = "";
      this.answerMode = "create";
    },

    startEditAnswer() {
      this.link = this.localItem.gitUrl || "";
      this.answer = this.localItem.answerText || "";
      this.answerFilesNew = [];
      this.answerFileError = "";
      this.answerMode = "edit";
    },

    removeFileLocal(fileId) {
      if (!this.localItem || !Array.isArray(this.localItem.files)) return;
      this.localItem.files = this.localItem.files.filter(f => String(f.id) !== String(fileId));
    },

    removeFile(payload) {
      const { fileId, attachmentType } = payload || {};
      this.delFile(fileId, attachmentType)
    },

    delFile(fileId, attachmentType) {
      this.$emit("delFile", {
        fileId: fileId,
        attachmentType: attachmentType,
        onSuccess: () => this.removeFileLocal(fileId),
      });
    },

  },
};
</script>

<style scoped>
.fs-14 {
  font-size: 14px;
}
.custom-content-list {
  padding: 12px 16px 0;
  align-items: flex-start;
}
.custom-content-list .v-list-item__content {
  padding: 0;
}
.text-h4-custom {
  font-size: 23px !important;
}
.markCard-description {
  min-height: 32px;
}
.center-icon {
  right: 7px !important;
  top: 2px !important;
}
.center-icon i::before {
  margin-top: 0;
}

</style>